export default __webpack_public_path__ + "assets/images/icon-incoming-group-call.6dfb082f490547186c07b2a42c6fd543.svg";